// src/services/ticketService.ts - VERSIÓN DE EMERGENCIA
import { buildApiUrl } from '../config/api';
import { ipService } from './ipService';

const API_BASE = import.meta.env.VITE_API_URL || 'https://app.ingeai7.com/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  console.log('🔑 [getAuthHeaders] Token existe:', !!token, 'Primeros 20 chars:', token?.substring(0, 20));
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const ticketService = {
  // Listar todos los tickets
  async getTickets(filters: any = {}) {
    console.log(`✅ [ticketService] Inicio de extraccion de Tickets`);
    try {
      // Verificar token antes de hacer la petición
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('❌ [ticketService] NO HAY TOKEN EN LOCALSTORAGE');
        throw new Error('No hay token de autenticación');
      }

      const params = new URLSearchParams();
      
      // Agregar filtros
      Object.keys(filters).forEach(key => {
        if (filters[key]) params.append(key, filters[key]);
      });

      const headers = getAuthHeaders();
      console.log('📋 [ticketService] Headers:', headers);
      console.log('📋 [ticketService] URL:', buildApiUrl(`/tickets?${params.toString()}`));

      const response = await fetch(buildApiUrl(`/tickets?${params.toString()}`), {
        method: 'GET',
        headers: headers,
        credentials: 'include'
      });

      console.log('📡 [ticketService] Response status:', response.status);
      console.log('📡 [ticketService] Response headers:', Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Error desconocido' }));
        console.error('❌ [ticketService] Error del servidor:', errorData);
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log(`✅ [ticketService] ${data.tickets?.length || 0} tickets obtenidos`);
      
      return data;
    } catch (error: any) {
      console.error('❌ [ticketService] Error completo:', {
        message: error.message,
        stack: error.stack
      });
      throw error;
    }
  },

  // Tickets de un usuario específico
  async getUserTickets(userId: string) {
    const response = await fetch(`${API_BASE}/tickets/user/${userId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al cargar tickets del usuario');
    }
    
    return response.json();
  },

  // Crear ticket
  async createTicket(ticketData: any) {
    try {
      console.log('📤 [ticketService] Creando ticket...');
      // ✅ OBTENER IP PÚBLICA
      const publicIp = await ipService.getPublicIP();
      const deviceInfo = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        publicIp: publicIp
      };
      let body;
      
      if (ticketData instanceof FormData) {
        console.log('🔎 [ticketService] Usando FormData directamente');
        body = ticketData;
        body.append('deviceInfo', JSON.stringify(deviceInfo));
      } else {
        console.log('📦 [ticketService] Convirtiendo objeto a FormData');
        const formData = new FormData();
        
        // ✅ AGREGAR DEVICE INFO
        formData.append('deviceInfo', JSON.stringify(deviceInfo));
        Object.keys(ticketData).forEach(key => {
          if (ticketData[key] !== undefined && ticketData[key] !== null) {
            formData.append(key, ticketData[key]);
          }
        });
        
        body = formData;
      }

      const response = await fetch(buildApiUrl('/tickets'), {
        method: 'POST',
        credentials: 'include',
        body: body
      });

      if (!response.ok) {
        const errorData = await response.json(); 
        console.error('❌ [ticketService] Error del servidor:', errorData);
        throw new Error(errorData.message || errorData.error || 'Error creando ticket');
      }

      const data = await response.json();
      console.log('✅ [ticketService] Ticket creado:', data.ticket?.id);
      return data;
    } catch (error) {
      console.error('❌ [ticketService] Error:', error);
      throw error;
    }
  },

  // Obtener detalle de ticket
  async getTicket(id: string) {
    const response = await fetch(`${API_BASE}/tickets/${id}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al cargar ticket');
    }
    
    return response.json();
  },

  // Cambiar estado (admin/agent)
  async updateStatus(id: string, status: string) {
    const response = await fetch(`${API_BASE}/tickets/${id}/status`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ status })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al actualizar estado');
    }
    
    return response.json();
  },

  // Actualizar ticket completo (admin/agent)
  async updateTicket(id: string, data: any) {
    const response = await fetch(`${API_BASE}/tickets/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al actualizar ticket');
    }
    
    return response.json();
  },

  // Eliminar ticket (solo admin)
  async deleteTicket(id: string) {
    const response = await fetch(`${API_BASE}/tickets/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al eliminar ticket');
    }
    
    return response.json();
  }
};